import React from 'react';

const MutateConcept = (props) => {
  return (
    <div>
      <p className="step-p">Edit the "Welcome to Blockchain Demo 2.0!" input! </p>

      <p className="step-p">Since data is an input variable for the hash, changing the data will change the hash. </p>

      <p className="step-p">The new hash will not have three leading zeros, and therefore becomes invalid.</p>
    </div>
  );
};

export default MutateConcept;


// WEBPACK FOOTER //
// ./src/steps/mutate/mutate-concept.js